'use strict';

var styled = require('styled-components');
var component = require('../Button/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const getBorderColor = ({ $active, theme }) => {
    if ($active) {
        return `
      border-color: ${theme.colors.primary.normal};
      &:hover, &.hover, &:focus, &.focus {
        border-color: ${theme.colors.primary.normal};
      }
    `;
    }
    return `
    &:focus, &.focus {
      border: ${theme.designTokens.buttonSecondaryBorder};
    }
    &:hover, &.hover {
      border: ${theme.designTokens.buttonSecondaryHoverBorder};
    }
  `;
};
const PillButtonStyled = styled__default.default(component.Button) `
  position: relative;
  width: 2rem;
  ${getBorderColor}
`;

exports.PillButtonStyled = PillButtonStyled;
//# sourceMappingURL=pillButton.styles.js.map
